(function () {
	const EL_NAME = '.hasTicker';
	const IN_VIEW_OFFSET_DESKTOP = 70;
	const IN_VIEW_OFFSET_MOBILE = 0;
	const elements = document.querySelectorAll(EL_NAME);

	if (!elements.length) {
		return;
	}

	init();

	function init() {
		window.onscroll = function () {
			elements.forEach(function (el) {
				if (!el.classList.contains('done') && isInView(el)) {
					countUp(el);
					el.classList.add('done');
				}
			});
		};
		window.dispatchEvent(new Event('scroll'));
	}

	function isInView(elem) {
		let offset = window.innerWidth >= 992 ? IN_VIEW_OFFSET_DESKTOP : IN_VIEW_OFFSET_MOBILE;
		let bounding = elem.getBoundingClientRect();
		return (bounding.top >= 0 && bounding.left >= 0
			&& bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
			&& bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) - offset
		);
	}

	function countUp(el) {
		let start;
		const number = el.getAttribute('data-number');
		const final = parseInt(number);
		const sfx = number.replace(final.toString(), '');
		const duration = 1500;
		const step = ts => {
			if (!start) {
				start = ts;
			}
			let progress = (ts - start) / duration;
			let value = Math.ceil(progress * final);
			let valueFormated = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
			let numberFormated = number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");

			if (final > 0) {
				el.textContent = (value < final ? valueFormated + sfx : numberFormated);
			}
			else {
				el.textContent = (value > final ? valueFormated + sfx : numberFormated);
			}
			if (progress < 1) {
				requestAnimationFrame(step);
			}
		};
		requestAnimationFrame(step);
	}
})();
